import { navigate } from 'gatsby'
import Text from 'components/Text'
import Button from 'components/Button'
import analytics from '@mobi/libraries/analytics'
import './LandingExpress.scss'
import { handlePerformanceMark } from 'utils/trackings/newRelicEvents'
import * as ROUTES from 'Routes'

const LandingExpress = () => {
  const handleRedirect = () => {
    analytics.track('segmentButtonClick', {
      name: 'VerAcordos',
      id: '7a2e99bd-d9df-4a9e-b3e8-45dba1bac898',
    })
    handlePerformanceMark(ROUTES.register.pageName)
    navigate('/registro', {
      state: {
        title:
          'Para consultar seus acordos vigentes, precisamos das seguintes informações:',
      },
    })
  }

  return (
    <div className="landing-express-container-express" id="BoletoExpress">
      <div className="content-express">
        <div className="description-express">
          <Text h2 size={1} className="label-text-express">
            Acesse sua 2ª via de boleto
          </Text>
          <Text p size={1} className="main-text-express">
            Consulte seu CPF, acesse seu acordo e baixe o boleto desse mês em
            minutos!
          </Text>

          <Button
            onClick={handleRedirect}
            className="button_express"
            role="button"
            data-tracking-location="lp"
            data-tracking-position="lp-cta"
            data-tracking-actionoutcome="redirect"
            data-tracking-element="button"
            data-tracking-outboundurl="https://www.gruporecovery.com/blog-conta-gov/"
          >
            Veja como se cadastrar
          </Button>
        </div>
      </div>
    </div>
  )
}

export default LandingExpress
